import { render, staticRenderFns } from "./ResponsiblePage.vue?vue&type=template&id=ccf444be&"
import script from "./ResponsiblePage.vue?vue&type=script&lang=js&"
export * from "./ResponsiblePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports